import {
  Button,
  Checkbox,
  FormControlLabel,
  MenuItem,
  TextField,
  Typography,
} from "@material-ui/core";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import React from "react";
import { apiPost, apiRequestNoLoadder } from "../../../utils/api_service";
import { API_URL } from "../../../constants/api";
import { ShowToast, toastType } from "../../../utils/toast-service";
import ConfirmDialog from "../../common/Dailogbox/confirmDailog";

class IndUploadBuildingPhoto extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      categories: [],
      selectedFile: null,
      selectedFileName: "",
      categoryId: "",
      caption: "",
      internalNotes: "",
      isPrimary: false,
      isSubmitting: false,
      isDragOver: false,
      thumbnailPreviewUrl: null,
      showSetPrimaryConfirm: false,
    };
    this.fileInputRef = React.createRef();
  }

  componentDidMount() {
    apiRequestNoLoadder({
      url: API_URL.Building.getImageCategoryMaster,
      params: { businessLineId: this.props.businessLineId || 2 },
    }).then(({ data }) => {
      this.setState({ categories: data || [] });
    });
  }

  componentWillUnmount() {}

  processFile = (file) => {
    if (!file) return;
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
    if (!allowedTypes.includes(file.type)) {
      ShowToast("Only image files (JPEG, JPG, PNG) are allowed.", toastType.ERROR);
      return;
    }
    if (file.size > 10 * 1024 * 1024) {
      ShowToast("File size must not exceed 10 MB.", toastType.ERROR);
      return;
    }

    this.setState({ selectedFile: file, selectedFileName: file.name });

    // Replicate server-side ResizeMode.Pad 150×100 (landscape) with white background (Quality 90)
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const THUMB_W = 150;
        const THUMB_H = 100;

        const scale = Math.min(THUMB_W / img.width, THUMB_H / img.height);
        const scaledW = Math.round(img.width * scale);
        const scaledH = Math.round(img.height * scale);
        const offsetX = Math.floor((THUMB_W - scaledW) / 2);
        const offsetY = Math.floor((THUMB_H - scaledH) / 2);

        const canvas = document.createElement("canvas");
        canvas.width = THUMB_W;
        canvas.height = THUMB_H;
        const ctx = canvas.getContext("2d");

        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, THUMB_W, THUMB_H);
        ctx.drawImage(img, offsetX, offsetY, scaledW, scaledH);

        this.setState({ thumbnailPreviewUrl: canvas.toDataURL("image/jpeg", 0.9) });
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  };

  handleFileChange = (e) => {
    this.processFile(e.target.files[0]);
    e.target.value = null;
  };

  handleDrop = (e) => {
    e.preventDefault();
    this.setState({ isDragOver: false });
    const file = e.dataTransfer.files[0];
    this.processFile(file);
  };

  handleDragOver = (e) => {
    e.preventDefault();
    this.setState({ isDragOver: true });
  };

  handleDragLeave = () => {
    this.setState({ isDragOver: false });
  };

  handleSubmit = () => {
    const { hasExistingPrimary } = this.props;
    const { selectedFile, categoryId, isPrimary } = this.state;

    if (!selectedFile) {
      ShowToast("Please select an image file.", toastType.ERROR);
      return;
    }
    if (!categoryId) {
      ShowToast("Please select a category.", toastType.ERROR);
      return;
    }

    // If setting as primary and another primary already exists, confirm first
    if (isPrimary && hasExistingPrimary) {
      this.setState({ showSetPrimaryConfirm: true });
      return;
    }

    this.doSubmit();
  };

  doSubmit = () => {
    const { buildingId, businessLineId, onSuccess } = this.props;
    const { selectedFile, categoryId, caption, internalNotes, isPrimary } = this.state;

    const formData = new FormData();
    formData.append("FormFile", selectedFile);
    formData.append("BuildingId", buildingId);
    formData.append("BusinessLineId", businessLineId || 2);
    formData.append("CategoryId", categoryId);
    formData.append("Caption", caption || "");
    formData.append("InternalNotes", internalNotes || "");
    formData.append("IsPrimary", isPrimary);

    this.setState({ isSubmitting: true });
    apiPost({ url: API_URL.Building.uploadBuildingImage, postBody: formData })
      .then(({ success }) => {
        this.setState({ isSubmitting: false });
        if (success) {
          onSuccess && onSuccess();
        } else {
          ShowToast("Upload failed. Please try again.", toastType.ERROR);
        }
      })
      .catch(() => {
        this.setState({ isSubmitting: false });
        ShowToast("An error occurred during upload.", toastType.ERROR);
      });
  };

  render() {
    const {
      categories,
      selectedFileName,
      categoryId,
      caption,
      internalNotes,
      isPrimary,
      isSubmitting,
      isDragOver,
      thumbnailPreviewUrl,
      showSetPrimaryConfirm,
    } = this.state;
    const { onCancel } = this.props;

    return (
      <div>
        {/* File Constraints */}
        <div style={{ marginBottom: "12px" }}>
          <Typography variant="body2" style={{ fontWeight: 600, marginBottom: "4px" }}>
            File Constraints
          </Typography>
          <div style={{ margin: 0, paddingLeft: "8px" }}>
            <Typography variant="caption" display="block">Max upload size: 10 MB</Typography>
            <Typography variant="caption" display="block">File Types: JPEG, JPG, PNG</Typography>
          </div>
        </div>

        {/* Drag & Drop Zone */}
        <div
          onDrop={this.handleDrop}
          onDragOver={this.handleDragOver}
          onDragLeave={this.handleDragLeave}
          onClick={() => this.fileInputRef.current.click()}
          style={{
            border: `2px dashed ${isDragOver ? "#064473" : "#ccc"}`,
            borderRadius: "6px",
            backgroundColor: isDragOver ? "#e8f0fe" : "#fafafa",
            padding: "24px",
            textAlign: "center",
            cursor: "pointer",
            marginBottom: "12px",
            transition: "all 0.2s",
          }}
        >
          <input
            type="file"
            ref={this.fileInputRef}
            hidden
            accept="image/jpeg,image/jpg,image/png"
            onChange={this.handleFileChange}
          />
          <CloudUploadIcon style={{ fontSize: "40px", color: "#999", marginBottom: "8px" }} />
          <Typography variant="body2" color="textSecondary">
            {selectedFileName ? selectedFileName : <span>Drag & drop or Click to upload <span style={{ color: "#f44336" }}>*</span></span>}
          </Typography>
          <Button
            className="action-button no-print"
            size="small"
            style={{ marginTop: "10px" }}
            onClick={(e) => { e.stopPropagation(); this.fileInputRef.current.click(); }}
          >
            <span className="tool-icon-text">Select Files</span>
          </Button>
        </div>

        {/* Caption */}
        <TextField
          label="Caption"
          value={caption}
          onChange={(e) => this.setState({ caption: e.target.value })}
          fullWidth
          size="small"
          margin="dense"
          variant="outlined"
          InputLabelProps={{ shrink: true, style: { color: "rgba(0,0,0,0.6)" } }}
          inputProps={{ maxLength: 500 }}
        />

        {/* Category */}
        <TextField
          select
          label={<span>Category <span style={{ color: "#f44336" }}>*</span></span>}
          value={categoryId}
          onChange={(e) => this.setState({ categoryId: e.target.value })}
          fullWidth
          size="small"
          margin="dense"
          variant="outlined"
          InputLabelProps={{ shrink: true, style: { color: "rgba(0,0,0,0.6)" } }}
          SelectProps={{ displayEmpty: true , style: { fontSize: 13 }}}
        >
          <MenuItem value=""><em>Select Category...</em></MenuItem>
          {categories.map((c) => (
            <MenuItem key={c.categoryId} value={c.categoryId}>
              {c.categoryName}
            </MenuItem>
          ))}
        </TextField>

        {/* Internal Notes */}
        <TextField
          label="Internal Notes"
          value={internalNotes}
          onChange={(e) => this.setState({ internalNotes: e.target.value })}
          fullWidth
          size="small"
          margin="dense"
          variant="outlined"
          InputLabelProps={{ shrink: true, style: { color: "rgba(0,0,0,0.6)" } }}
          multiline
          rows={3}
          inputProps={{ maxLength: 1000 }}
        />

        {/* Is Primary */}
        <FormControlLabel
          control={
            <Checkbox
              checked={isPrimary}
              onChange={(e) => this.setState({ isPrimary: e.target.checked })}
              color="primary"
              size="small"
            />
          }
          label={<span style={{ fontSize: 14 }}>Set as Primary Photo</span>}
          style={{ marginTop: "8px" }}
        />

        {showSetPrimaryConfirm && (
          <ConfirmDialog
            IsOpen={showSetPrimaryConfirm}
            Message="A primary image already exists for this property. This will replace it as the primary image. Do you want to proceed?"
            OnHandelClick={(confirmed) => {
              this.setState({ showSetPrimaryConfirm: false });
              if (confirmed) this.doSubmit();
            }}
            AgreeText="Yes, Set as Primary"
            DisAgreeText="Cancel"
          />
        )}

        {/* Thumbnail + Web Preview */}
        <div style={{ display: "flex", alignItems: "flex-start", gap: "24px", marginTop: "8px" }}>
          {/* Thumbnail Preview */}
          <div style={{ textAlign: "center" }}>
            <Typography variant="caption" display="block" style={{ marginBottom: "4px" }}>
              Thumbnail preview
            </Typography>
            <div
              style={{
                width: "150px",
                height: "100px",
                border: "1px solid #ddd",
                borderRadius: "4px",
                backgroundColor: "#f5f5f5",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
              }}
            >
              {thumbnailPreviewUrl ? (
                <img src={thumbnailPreviewUrl} alt="thumbnail" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
              ) : (
                <Typography variant="caption" color="textSecondary" style={{ fontSize: "10px", textAlign: "center", padding: "4px" }}>
                  Preview here (150x100)
                </Typography>
              )}
            </div>
          </div>

        </div>

        {/* Actions */}
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", marginTop: "16px" }}>
          <Button className="action-button no-print" size="small" onClick={onCancel} disabled={isSubmitting}>
            <span className="tool-icon-text">Cancel</span>
          </Button>
          <Button
            className="action-button no-print"
            size="small"
            onClick={this.handleSubmit}
            disabled={isSubmitting}
          >
            <span className="tool-icon-text">{isSubmitting ? "Uploading..." : "Save"}</span>
          </Button>
        </div>
      </div>
    );
  }
}

export default IndUploadBuildingPhoto;
